import { useState } from 'react'
import { FaDesktop, FaMobileAlt, FaQrcode, FaCopy, FaCheck, FaKeyboard, FaCamera, FaMicrophone } from 'react-icons/fa'
import QRCodeGenerator from '../components/tools/QRCodeGenerator'
import ClipboardTool from '../components/tools/ClipboardTool'
import KeyboardTester from '../components/tools/KeyboardTester'
import './Tools.css'

function Tools() {
  const [activeTool, setActiveTool] = useState(null)

  const tools = [
    {
      id: 'qrcode',
      icon: <FaQrcode />,
      title: '二维码生成器',
      description: '生成自定义文本或 URL 的二维码',
      component: <QRCodeGenerator />,
      platforms: ['desktop', 'mobile']
    },
    {
      id: 'clipboard',
      icon: <FaCopy />,
      title: '剪贴板工具',
      description: '管理剪贴板历史记录',
      component: <ClipboardTool />,
      platforms: ['desktop']
    },
    {
      id: 'keyboard',
      icon: <FaKeyboard />,
      title: '键盘测试',
      description: '测试键盘按键是否正常工作',
      component: <KeyboardTester />,
      platforms: ['desktop']
    }
  ]

  const renderPlatformIcons = (platforms) => {
    return (
      <div className="tool-platforms">
        {platforms.includes('desktop') && (
          <span className="platform-tag desktop" title="电脑端可用">
            <FaDesktop /> 电脑
          </span>
        )}
        {platforms.includes('mobile') && (
          <span className="platform-tag mobile" title="移动端可用">
            <FaMobileAlt /> 手机
          </span>
        )}
      </div>
    )
  }

  return (
    <div className="tools-page">
      <header className="page-header">
        <h1>实用工具</h1>
        <p>常用的 Web 工具集合，部分功能仅在特定平台可用</p>
      </header>

      {activeTool ? (
        <div className="tool-active">
          <button 
            className="back-button"
            onClick={() => setActiveTool(null)}
          >
            ← 返回工具列表
          </button>
          <div className="tool-content">
            {tools.find(t => t.id === activeTool)?.component}
          </div>
        </div>
      ) : (
        <div className="tools-grid">
          {tools.map((tool) => (
            <div
              key={tool.id}
              className="tool-card"
              onClick={() => setActiveTool(tool.id)}
            >
              <div className="tool-icon">{tool.icon}</div>
              <h3 className="tool-title">{tool.title}</h3>
              <p className="tool-description">{tool.description}</p>
              {renderPlatformIcons(tool.platforms)}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Tools